module.exports = __webpack_public_path__ + "img/download-1-INTphone.31915c5a.png";